var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTech1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.7956 18.7642H40.61C40.7465 18.7642 40.8765 18.7772 41 18.8033V18.7902L37.8216 15.6035H33.3237L30.3013 18.6338H11.6922L8.66981 15.6035H4.17192L1 18.7967V18.8098C1.13 18.7837 1.25999 18.7707 1.38999 18.7707H4.20442C5.42639 18.7707 6.42736 19.7743 6.42736 20.9994C6.42736 22.2246 5.42639 23.2281 4.20442 23.2281H1.38999C1.25349 23.2281 1.1235 23.2151 1 23.189V23.2998L4.17842 26.4865H8.67631L11.8092 23.3455H30.1908L33.3237 26.4865H37.8216L41 23.2998V23.189C40.87 23.2151 40.74 23.2281 40.61 23.2281H37.7956C36.5736 23.2281 35.5726 22.2246 35.5726 20.9994C35.5726 19.7743 36.5736 18.7707 37.7956 18.7707V18.7642Z",
    stroke: "#3273B6",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.876 5.68555V15.5063",
    stroke: "#3273B6",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.876 5.73118C22.1791 5.73118 23.2355 4.67207 23.2355 3.36559C23.2355 2.05911 22.1791 1 20.876 1C19.573 1 18.5166 2.05911 18.5166 3.36559C18.5166 4.67207 19.573 5.73118 20.876 5.73118Z",
    stroke: "#3273B6",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4219 11.6609C35.725 11.6609 36.7814 10.6018 36.7814 9.29528C36.7814 7.9888 35.725 6.92969 34.4219 6.92969C33.1189 6.92969 32.0625 7.9888 32.0625 9.29528C32.0625 10.6018 33.1189 11.6609 34.4219 11.6609Z",
    stroke: "#3273B6",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2451 15.5074V9.29688H32.0634",
    stroke: "#3273B6",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58503 11.6609C8.88811 11.6609 9.94447 10.6018 9.94447 9.29528C9.94447 7.9888 8.88811 6.92969 7.58503 6.92969C6.28194 6.92969 5.22559 7.9888 5.22559 9.29528C5.22559 10.6018 6.28194 11.6609 7.58503 11.6609Z",
    stroke: "#3273B6",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7614 15.5074V9.29688H9.93652",
    stroke: "#3273B6",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.876 36.313V26.4922",
    stroke: "#3273B6",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.876 41.0007C22.1791 41.0007 23.2355 39.9416 23.2355 38.6351C23.2355 37.3286 22.1791 36.2695 20.876 36.2695C19.573 36.2695 18.5166 37.3286 18.5166 38.6351C18.5166 39.9416 19.573 41.0007 20.876 41.0007Z",
    stroke: "#3273B6",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4219 35.0632C35.725 35.0632 36.7814 34.0041 36.7814 32.6976C36.7814 31.3911 35.725 30.332 34.4219 30.332C33.1189 30.332 32.0625 31.3911 32.0625 32.6976C32.0625 34.0041 33.1189 35.0632 34.4219 35.0632Z",
    stroke: "#3273B6",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2451 26.4922V32.6962H32.0634",
    stroke: "#3273B6",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58503 35.0632C8.88811 35.0632 9.94447 34.0041 9.94447 32.6976C9.94447 31.3911 8.88811 30.332 7.58503 30.332C6.28194 30.332 5.22559 31.3911 5.22559 32.6976C5.22559 34.0041 6.28194 35.0632 7.58503 35.0632Z",
    stroke: "#3273B6",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7614 26.4922V32.6962H9.93652",
    stroke: "#3273B6",
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTech1);
export default __webpack_public_path__ + "static/media/tech1.2ba46257450b0b9d2d2cd23b4df3ba1d.svg";
export { ForwardRef as ReactComponent };